import { Pipe, type PipeTransform } from '@angular/core';

export enum Logo {
    MALOU = 'malou',
}

@Pipe({
    name: 'logoPathResolver',
    standalone: true,
})
export class LogoPathResolverPipe implements PipeTransform {
    transform(key: string, options?: { folder?: string; extension?: string }): string {
        const extension = options?.extension ?? 'png';
        if (options?.folder) {
            return `/assets/logos/${options.folder}/${key}.${extension}`;
        }
        return `/assets/logos/${key}.${extension}`;
    }
}
